import css from './SeasonListItem.module.scss'
import React from 'react'
import { useTranslation } from 'react-i18next'
import MediaQuery from 'react-responsive'
import classNames from 'classnames'

import { BreakpointsMaxWidth } from 'meta/layout/breakpoints'
import { CollectionFromIframe, CollectionTypeTicket } from 'meta/pages/collection'
import { useAppDispatch } from 'store'
import { CheckoutActions } from 'store/pages/checkout'
import { Dates } from 'utils/dates'
import { shortenNameIfLongerThan } from 'utils/string'

import { ButtonWhiteBlack } from 'components/Actions/Action'
import Img from 'components/Media/Img'
import { useUrlCloudfront } from 'hooks/useEnv'
import { ITypeTicketCollectionData } from 'meta/pages/v4/typeticketcollection'

interface Props {
  collectionId: string
  data: ITypeTicketCollectionData
}

const SeasonListItem: React.FC<Props & CollectionFromIframe> = (props) => {
  const { collectionId, data, fromIframe, toggleContent } = props

  const {
    id,
    assets,
    dateStart,
    dateEnd,
    eventCount,
    name
  } = data

  const ITEM_NAME_MAX_LENGTH = 40

  const { t } = useTranslation()

  const dispatch = useAppDispatch()

  // const priceObj = minPrice ?? priceFrom

  const isDisabled = false

  const urlCloudfront = useUrlCloudfront()

  const placeholderImgUrl = `${urlCloudfront}/images/carousel/placeholders/square_cover_ticketsms_placeholder.svg`

  const openCheckout = () => {
    fromIframe && toggleContent && toggleContent()

    !isDisabled &&
      dispatch(
        CheckoutActions.init({
          codeUrl: collectionId,
          typeTicketCollectionId: String(id),
          insideIFrame: Boolean(fromIframe),
        })
      )
  }

  return (
    <div className={classNames(css.eventListItemContainer, { [css.disabled]: isDisabled })} onClick={openCheckout}>
      <div className={css.infoContainer}>
        <MediaQuery maxWidth={BreakpointsMaxWidth.mobile}>
          <div className={css.mobileImgContainer}>
            {assets.length > 0 && <img src={assets[0].url} className={css.image} />}
            {assets.length > 0 && <div className={css.bgBlackOverlay} />}
            {assets.length == 0 && <img src={placeholderImgUrl} className={css.image} />}
            <div className={css.text}>
              <div className={css.from}>
                <span className={css.txt}>{t('collection:season_tickets_dates_from')}</span>
                <span className={css.dateFrom}>
                  {Dates.format(dateStart.date_tz, t('dates:common:collection_season_mobile_from'))}
                </span>
              </div>
              <div className={css.to}>
                <span className={css.txt}>{t('collection:season_tickets_dates_to')}</span>
                <span className={css.dateTo}>
                  {Dates.format(dateEnd.date_tz, t('dates:common:collection_season_mobile_to'))}
                </span>
              </div>
            </div>
          </div>
        </MediaQuery>
        <MediaQuery minWidth={BreakpointsMaxWidth.mobile}>
          {assets.length > 0 && <img src={assets[0].url} className={css.image} />}
          {assets.length == 0 && <img src={placeholderImgUrl} className={css.image} />}
        </MediaQuery>

        <div className={css.details}>
          <MediaQuery maxWidth={BreakpointsMaxWidth.mobile}>
            <h3 className={css.name}>{shortenNameIfLongerThan(name, ITEM_NAME_MAX_LENGTH)}</h3>
          </MediaQuery>
          <MediaQuery minWidth={BreakpointsMaxWidth.mobile}>
            <h3 className={css.name}>{name}</h3>
          </MediaQuery>
          <div className={classNames(css.seasonTicketsfor, { [css.longTitle]: name.length > ITEM_NAME_MAX_LENGTH })}>
            {t('collection:season_tickets_for')}
            <span>{t('collection:season_tickets_no_events', { num: eventCount })}</span>
          </div>
          <div className={css.detailed}>
            <MediaQuery maxWidth={BreakpointsMaxWidth.tablet}>
              <span className={css.datesNo}>{t('collection:season_tickets_no_dates', { num: eventCount })}</span>
              {/*{!isDisabled && Boolean(priceObj) && (
                <>
                  {t('collection:starting_from')}
                  <span className={css.priceFrom}>{priceObj && priceObj?.formatted}</span>
                </>
              )}*/}
              {isDisabled && (
                <>
                  <span className={css.notAvailable}>{t('collection:tickets')}</span>
                  <span className={css.priceFrom}>{t('collection:not_available')}</span>
                </>
              )}
            </MediaQuery>
            <MediaQuery minWidth={BreakpointsMaxWidth.tablet}>
              <span className={css.datesNo}>{t('collection:season_tickets_no_dates', { num: eventCount })}</span>
              {t('collection:season_tickets_dates_from')}
              <span className={css.dateFrom}>
                {Dates.format(dateStart.date_tz, t('dates:common:collection_season_from'))}
              </span>
              {t('collection:season_tickets_dates_to')}
              <span className={css.dateTo}>{Dates.format(dateEnd.date_tz, t('dates:common:collection_season_to'))}</span>
              {/*{Boolean(priceObj) && t('collection:season_tickets_dates_dot')}
              {!isDisabled && Boolean(priceObj) && (
                <>
                  {t('collection:price_from')}
                  <span className={css.priceFrom}>{priceObj && priceObj?.formatted}</span>
                </>
              )}*/}
              {isDisabled && (
                <>
                  {t('collection:tickets')}
                  <span className={css.priceFrom}>{t('collection:not_available')}</span>
                </>
              )}
            </MediaQuery>
          </div>
        </div>
      </div>

      {!isDisabled && (
        <MediaQuery minWidth={BreakpointsMaxWidth.tablet}>
          <div className={css.action}>
            <ButtonWhiteBlack className={css.button} onClick={openCheckout}>
              <h5>{fromIframe ? t('collection:purchase') : t('collection:see_season_ticket')}</h5>{' '}
              <Img alt="" src="/icons/arrow_right.svg" />
            </ButtonWhiteBlack>
          </div>
        </MediaQuery>
      )}
    </div>
  )
}

export default SeasonListItem
